import React from "react";
import {TextInputField, Dialog, Pane, Button, toaster, Strong, Select} from "evergreen-ui";
import {updateBooking, getBooking} from "../external/actions";
import {getCurrency} from "../util";
import {connect} from "react-redux";


class PayNowDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            amount: "",
            discount: 0,
            transactionCode: "",
            value: 0,
            mode: "No Pay",
            noPay: false,
            selectedTransactionMode: 0,
            invalidAmount: false,
            emptyAmount: false,
            invalidDiscount: false
        };
        this.baseState = this.state;
    }

    confirmPayNow = async () => {
        const {
            bookingDetails
        } = this.props;
        let {
            amount,
            discount,
            value
        } = this.state;
        amount = parseFloat(amount);
        discount = parseFloat(discount);
        if (amount > bookingDetails["balance"]) {
            this.setState({
                invalidDiscount: false,
                emptyAmount: false,
                invalidAmount: true,
            });
        } else if (!amount) {
            toaster.warning("Amount can not be empty");
            this.setState({
                invalidDiscount: false,
                invalidAmount: false,
                emptyAmount: true,
            });
        } else if (discount > bookingDetails["balance"]) {
            this.setState({
                invalidDiscount: true,
                emptyAmount: false,
                invalidAmount: false,
            });
        } else {
            this.setState({
                invalidDiscount: false,
                emptyAmount: false,
                invalidAmount: false,
            });
            await this.props.dispatch(updateBooking({
                bookingId: bookingDetails.bookingId,
                patternBookingId: null,
                amount: amount,
                discount: discount,
                transactionData: {
                    mode: value,
                    type: 3,
                },
            }));
            if (this.props.payNowData["requestStatus"] === 1) {
                toaster.success("Payment Updated");
                await this.onCloseDialog(bookingDetails.bookingId);
            } else {
                toaster.danger(this.props.payNowData.message);
            }
        }
    };

    onPaymentModeChange = async (e) => {
        let {amount} = this.state;
        if (amount > 0) {
            this.setState({
                value: e.target.value,
                emptyAmount: false,
            });
        } else {
            this.setState({
                emptyAmount: true,
            });
        }
    };

    onAmountChange = async (e) => {
        let amount = e.target.value;
        let {value} = this.state;
        this.setState({
            amount: amount,
        });
        if (value === 0 && amount > 0) {
            await this.setState({
                value: 1,
                noPay: true,
                emptyAmount: false,
            });
        }
        if (amount <= 0) {
            await this.setState({
                value: 0,
                noPay: false,
            });
        }
    };

    onCloseDialog = async (bookingId) => {
        const {showPayNowDialog} = this.props;
        if (bookingId) {
            let reqParams = {
                bookingId: bookingId,
            };
            await this.props.dispatch(getBooking(reqParams));
        }
        this.setState({
            ...this.baseState
        });
        showPayNowDialog(false, bookingId);
    };

    render() {
        const {
            invalidDiscount,
            emptyAmount,
            invalidAmount,
            noPay
        } = this.state;

        const {
            isShown,
            bookingDetails,
            transactionMode
        } = this.props;

        let {
            balance
        } = bookingDetails;
        const currency = getCurrency();

        return (
            <Dialog
                isShown={isShown}
                title="Pay Now"
                onCloseComplete={() => this.onCloseDialog()}
                hasFooter={false}
            >
                <Pane
                    display={"flex"}
                    justifyContent={"space-between"}
                    alignItems={"center"}
                >
                    <TextInputField
                        width={"55%"}
                        marginRight={10}
                        type={"number"}
                        label={"Amount"}
                        placeholder={currency}
                        isInvalid={invalidAmount || emptyAmount}
                        validationMessage={invalidAmount && "Amount is greater than balance"}
                        onChange={(e) => this.onAmountChange(e)}
                    />
                    {transactionMode &&
                    transactionMode["transactionCodes"] &&
                    transactionMode["transactionCodes"]["transactionModes"] ? (
                        <Select
                            width={"45%"}
                            marginLeft={10}
                            marginBottom={invalidAmount && 40}
                            value={this.state.value}
                            onChange={(event) => this.onPaymentModeChange(event)}
                        >
                            {noPay
                                ? Object.entries(
                                    transactionMode &&
                                    transactionMode["transactionCodes"] &&
                                    transactionMode["transactionCodes"]["transactionModes"]
                                )
                                    .filter((mode) => mode[0] !== "0")
                                    .map((mode) => (
                                        <option key={mode[0]} value={mode[0]}>
                                            {mode[1]}
                                        </option>
                                    ))
                                : Object.entries(
                                    transactionMode &&
                                    transactionMode["transactionCodes"] &&
                                    transactionMode["transactionCodes"]["transactionModes"]
                                ).map((mode) => (
                                    <option key={mode[0]} value={mode[0]}>
                                        {mode[1]}
                                    </option>
                                ))}
                        </Select>
                    ) : null}
                </Pane>
                <TextInputField
                    label={"Discount"}
                    type={"number"}
                    width={"55%"}
                    placeholder={currency}
                    isInvalid={invalidDiscount}
                    validationMessage={invalidDiscount && "Invalid discount amount"}
                    onChange={(e) => this.setState({discount: parseInt(e.target.value)})}
                />
                <Pane
                    display={"flex"}
                >
                    <Strong>Balance</Strong>
                    <Strong marginLeft={20}>{`${currency} ${balance}`}</Strong>
                </Pane>
                <Pane
                    display={"flex"}
                    marginTop={20}
                    flexDirection={"row"}
                    justifyContent={"center"}
                    alignItems={"center"}
                >
                    <Button
                        width={"100%"}
                        display={"flex"}
                        justifyContent={"center"}
                        appearance="primary"
                        margin={"auto"}
                        onClick={() => this.confirmPayNow()}
                    >
                        Confirm
                    </Button>
                </Pane>
            </Dialog>
        );
    }
}

const mapStateToProps = (
    {
        transactionCodesData,
        payNowData
    }) => ({
        transactionCodesData,
        payNowData,
    }
);

export default connect(mapStateToProps)(PayNowDialog);
